module.exports = __webpack_public_path__ + "static/media/ec.665ce90e.svg";